import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

const DetailHeader = () => {
	const { moreInfoCard } = useContext(SportsCampsContext);

	return (
		<header className="c-detail-fiche__header">
			<div className="text">
				<h2 className="title">{moreInfoCard.activityName}</h2>
			</div>
		</header>
	);
};

export default DetailHeader;
